import React from "react";
type Tone = "green" | "amber" | "red" | "gray";
type StatusChipProps = {
  children: React.ReactNode;
  tone?: Tone;
  dot?: boolean;
};
const tones: Record<Tone, string> = {
  green: "bg-[#e4f4e8] text-[#176B3A]",
  amber: "bg-[#fff3dc] text-[#a65f00]",
  red: "bg-[#fde9e9] text-[#b42323]",
  gray: "bg-[#edf1ee] text-[#506158]"
};
export function StatusChip({
  children,
  tone = "green",
  dot = false
}: StatusChipProps) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold ${tones[tone]}`} data-id="element-174" data-mp="3lm5r8qq898r3">{dot && <span className={`h-1.5 w-1.5 rounded-full ${tone === "green" ? "bg-[#176B3A]" : tone === "amber" ? "bg-[#D99000]" : "bg-[#D62828]"}`} data-id="element-175" data-mp="3gkgglc6x2x3j" />} {children}</span>;
}